import {
	getDocumentSigningEventTypes,
	logDocumentSigningEvent,
	LoggingEvent,
} from "@/api/guest-document-signature-events";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { GUEST_DOCUMENT_SIGNATURE_EVENT_KEYS } from "./keys";

export const documentSigningEventTypesQueryOptions = (locationId: number) =>
	queryOptions({
		queryKey: GUEST_DOCUMENT_SIGNATURE_EVENT_KEYS.eventTypes(locationId),
		queryFn: () => getDocumentSigningEventTypes(locationId),
		staleTime: Number.POSITIVE_INFINITY,
	});

export function useDocumentSigningEvents(locationId: number) {
	const eventMutation = useMutation({
		mutationFn: (eventType: LoggingEvent) =>
			logDocumentSigningEvent(locationId, eventType),
	});

	const trackEvent = (eventType: LoggingEvent) => {
		eventMutation.mutate(eventType);
	};

	return {
		trackEvent,
	};
}
